<template>
  <div>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      light
      top
    >
      {{ snackbar.message }}
      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="handleSnackbarAction"
        >
          {{ snackbar.actionText || $t('contact.title') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'App',

    metaInfo: {
      title: 'App',
      titleTemplate: '%s | SINO INTELLIGENT EQUIPMENT',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },

    data() {
      return {
        snackbar: {
          show: false,
          message: '',
          color: 'info',
          timeout: 3000,
          actionText: '',
          actionCallback: null,
        },
      }
    },
    created() {
      // 将方法挂载到 Vue 原型上，方便全局调用
      this.$root.$showSnackbar = this.showSnackbar
    },
    methods: {
      showSnackbar(options) {
        this.snackbar = {
          show: true,
          message: options.message || '',
          color: options.color || 'info',
          timeout: options.timeout || 3000,
          actionText: options.actionText || '',
          actionCallback: options.actionCallback || null,
        }
      },

      handleSnackbarAction() {
        if (this.snackbar.actionCallback) {
          // 执行回调（回调中已包含滚动逻辑）
          this.snackbar.actionCallback()
        }
        this.snackbar.show = false
        // 注意：如果 actionCallback 存在，滚动逻辑已在回调中处理
        // 如果不存在，可能需要其他处理（暂时不滚动，因为大多数情况都在回调中处理）
      },
    },
  }
</script>

<style lang="sass">
  .extra-padding
    padding-bottom: 96px !important
    padding-top: 96px !important

    @media screen and (max-width: 959px)
      padding-top: 48px !important
      padding-bottom: 48px !important
  .v-snack__wrapper
    padding: 2px 12px !important
</style>
